import React from 'react';
import {Box, Image, Text, useBreakpointValue} from '@chakra-ui/react'; // Import relevant components
import PropTypes from 'prop-types';


const ImageWithLegend = ({data}) => {

    ImageWithLegend.propTypes = {
        data: PropTypes.shape({
            image: PropTypes.string.isRequired,
            mobileImage: PropTypes.string,
            imageLegend: PropTypes.string
        }),
    };

    const isMobile = useBreakpointValue({base: true, md: false});

    return (
        <React.Fragment>
            <Box pb={{base: '56px', md: '56px', lg: '77px'}}>
                <Image
                    src={isMobile ? data.mobileImage : data.image}
                    alt={data.imageLegend}/>
                <Text mt="24px" fontSize="16px">{data.imageLegend}</Text>
            </Box>
        </React.Fragment>
    );
};

export default ImageWithLegend;